import React from "react";
import { Button, useNotify, useRefresh } from "react-admin";
import FormModal from "server/components/Modals/FormModal";
import { MoneyInput } from "server/components/Fields/MoneyInput";
import EditIcon from "@mui/icons-material/Edit";
import dataProvider from "server/dataProvider";
import { specialistRequests } from "api/specialistApi";

const UpdatePriceDialog = ({ year }) => {
  const notify = useNotify();
  const refresh = useRefresh();

  const handleSubmit = async data => {
    await dataProvider.customRequest(
      specialistRequests.updateHealthcareCourseDailyPrices(year),
      { price: data.price },
      "PUT",
    );
    notify("Успешна редакция на дневна такса", { type: "success" });
    refresh();
  };
  return (
    <FormModal
      onConfirm={handleSubmit}
      titleContent={"Редактирай на дневна такса"}
      triggerButton={
        <Button
          label="Редактирай"
          startIcon={<EditIcon />}
        />
      }
    >
      <MoneyInput
        source="price"
        label="Дневна такса (EUR)"
      />
    </FormModal>
  );
};

export default UpdatePriceDialog;
